
define('text!views/shared/video_iframe/video_iframe.html',[],function () { return '<iframe \r\n\tsrc="https://player.vimeo.com/video/<%- this.videoID %>?autoplay=<%- this.autoPlay %>&title=0&byline=0&portrait=0"\r\n\tframeborder="0"\r\n\twebkitallowfullscreen mozallowfullscreen allowfullscreen>\r\n</iframe>';});

